export const USER_SUCCESSFULLY_AUTHENTICATED = 'USER_SUCCESSFULLY_AUTHENTICATED';

export const userSuccessfullyAuthenticated = () => ({
  type: USER_SUCCESSFULLY_AUTHENTICATED
});
